"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactListCreatedStatus = exports.ReservedListTypeEnum = void 0;
var ReservedListTypeEnum;
(function (ReservedListTypeEnum) {
    ReservedListTypeEnum["AllContacts"] = "AllContacts";
    ReservedListTypeEnum["CommunicationPreference"] = "CommunicationPreference";
    ReservedListTypeEnum["ActiveMembers"] = "ActiveMembers";
    ReservedListTypeEnum["AutoRenewMembers"] = "AutoRenewMembers";
    ReservedListTypeEnum["ExpiringMembers"] = "ExpiringMembers";
    ReservedListTypeEnum["LapsedMembers"] = "LapsedMembers";
    ReservedListTypeEnum["RecurringDonors"] = "RecurringDonors";
    ReservedListTypeEnum["LapsedRecurringDonors"] = "LapsedRecurringDonors";
    ReservedListTypeEnum["TotalSupporters"] = "TotalSupporters";
    ReservedListTypeEnum["CampaignGuests"] = "CampaignGuests";
})(ReservedListTypeEnum || (exports.ReservedListTypeEnum = ReservedListTypeEnum = {}));
var ContactListCreatedStatus;
(function (ContactListCreatedStatus) {
    ContactListCreatedStatus["Automatic"] = "automatic";
    ContactListCreatedStatus["Imported"] = "imported";
    ContactListCreatedStatus["Manual"] = "manual";
})(ContactListCreatedStatus || (exports.ContactListCreatedStatus = ContactListCreatedStatus = {}));
